import { Mic } from "lucide-react";
import { cn } from "../../lib/utils";
import { GYM_STUDIO as C } from "../../lib/gym/gymStudioTheme";

export interface GymStepPromptCardProps {
  stepNumber: number;
  instruction: string;
  isListening?: boolean;
  volume?: number;
  showMic?: boolean;
}

/** Instrucción del paso actual, flotando sobre el mástil. */
export function GymStepPromptCard({
  stepNumber,
  instruction,
  isListening = false,
  volume = 0,
  showMic = false,
}: GymStepPromptCardProps) {
  return (
    <div
      key={instruction}
      className="absolute top-3 left-1/2 z-30 w-[min(92%,420px)] -translate-x-1/2 pointer-events-none gym-step-prompt"
    >
      <div
        className="flex items-center gap-3 px-4 py-3 rounded-2xl"
        style={{
          background: "rgba(28,26,25,0.9)",
          border: `1px solid ${C.borderHover}`,
          boxShadow: "0 12px 40px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.06)",
        }}
      >
        <span
          className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shrink-0"
          style={{ backgroundColor: C.accentSoft, color: C.accent }}
        >
          {stepNumber}
        </span>
        <p className="text-sm font-medium leading-snug flex-1" style={{ color: C.textMain }}>
          {instruction}
        </p>
        {showMic && (
          <span
            className="flex items-center gap-1 text-[10px] font-medium shrink-0 px-2 py-1 rounded-full"
            style={{
              backgroundColor: isListening ? "rgba(34,197,94,0.18)" : "rgba(255,255,255,0.06)",
              color: isListening ? "#86efac" : C.textDim,
            }}
          >
            <Mic className={cn("w-3 h-3", isListening && volume > 0.01 && "animate-pulse")} />
            {isListening ? "ON" : "—"}
          </span>
        )}
      </div>
      <style>{`
        .gym-step-prompt { animation: gymStepIn 0.28s ease-out both; }
        @keyframes gymStepIn {
          from { opacity: 0; transform: translate(-50%, -8px); }
          to { opacity: 1; transform: translate(-50%, 0); }
        }
      `}</style>
    </div>
  );
}
